import { datadogLogs } from '@datadog/browser-logs';
export const initDatadogLogs = (config) => {
    if (config.env === 'local') {
        return;
    }
    datadogLogs.init(Object.assign({ clientToken: 'pub674cdda2ac0904efc0a20c07c43a29f5', site: 'datadoghq.com', sessionSampleRate: 100, silentMultipleInit: true, forwardConsoleLogs: [], forwardErrorsToLogs: false }, config));
};
//# sourceMappingURL=datadog.js.map